import axios from "axios";
import React, { useEffect, useState } from "react";
import { Header, Grid, Button } from "semantic-ui-react";
import { BaseUrl } from "../formcomponents/Constants";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import { AiFillEdit } from "react-icons/ai";
import { useNavigate } from "react-router-dom";
const ListUser = () => {
  useEffect(() => {
    getUserList();
  }, []);

  const [rowData, setrowData] = useState(null);
  const navigate = useNavigate();
  const getUserList = async () => {
    await axios
      .get(BaseUrl + "getListUserDetails")
      .then((res) => {
        console.log(res.data);
        setRecordForTable(res.data);
      })
      .catch((error) => {
        console.log(error);
      });
  };
  const setRecordForTable = (record) => {
    const tempRecord = record.map(
      ({
        userId,
        userFirstName,
        userLastName,
        contactNum,
        alternateContact,
        userEmail,
        nationality,
      }) => ({
        userId: userId,
        userFirstName: userFirstName,
        userLastName: userLastName,
        contactNum: contactNum,
        alternateContact: alternateContact,
        userEmail: userEmail,
        nationality: nationality,
      })
    );
    setrowData(tempRecord);
  };

  const columnDefs = [
    { headerName: "First Name ", field: "userFirstName" },

    { headerName: "Last Name", field: "userLastName" },
    { headerName: "Contact Number", field: "contactNum" },
    { headerName: "Alternative Number", field: "alternateContact" },
    { headerName: "E-Mail", field: "userEmail" },
    { headerName: "Nationality", field: "nationality" },

    {
      headerName: "Edit",
      filter: false,
      field: "userId",
      cellRendererFramework: (params) => (
        <div>
          <Button color="primary" onClick={() => updateRecord(params)}>
            <AiFillEdit />
          </Button>
        </div>
      ),
    },
  ];
  const defaultColDef = {
    sortable: true,
    editable: true,
    flex: 1,
    filter: true,
    floatingFilter: true,
  };
  const updateRecord = (params) => {
    console.log("Params", params.data);
    navigate(`/create-company/${params.data.userEmail}/${params.data.userId}`);
  };
  return (
    <div>
      <Grid.Row>
        <Header dividing size="huge" as="h1">
          User List
        </Header>
      </Grid.Row>
      <Grid.Row>
        <div className="ag-theme-alpine" style={{ height: 600 }}>
          <AgGridReact
            rowData={rowData}
            columnDefs={columnDefs}
            defaultColDef={defaultColDef}
            pagination={true}
          ></AgGridReact>
        </div>
      </Grid.Row>
    </div>
  );
};

export default ListUser;
